import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SpecialServicesHero from './components/SpecialServicesHero';
import ServicesGrid from './components/ServicesGrid';
import VisaHighlight from './components/VisaHighlight';
import HowItWorks from './components/HowItWorks';
import PlanMyTripForm from './components/PlanMyTripForm';
import ServicesCTA from './components/ServicesCTA';

export default function SpecialServicesPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar dark />
      <main>
        <SpecialServicesHero />
        <ServicesGrid />
        <VisaHighlight />
        <HowItWorks />
        <PlanMyTripForm />
        <ServicesCTA />
      </main>
      <Footer />
    </div>
  );
}